import { z } from "zod";

export const CheckReportDownloadStatusInputSchema = z.object({
    id: z.string(),
});

export type CheckReportDownloadStatusInput = z.infer<typeof CheckReportDownloadStatusInputSchema>;